module.exports = __webpack_public_path__ + "img/strap_length.4c68525b.png";